import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material"
import { useState } from "react"
import Icons from "../../../assets/js/Icons"

const AccessCodeDialog = ({ open, onClose, onSubmit, accessCode: webinarAccessCode }) => {
  const [accessCode, setAccessCode] = useState("")
  const [error, setError] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()
    if (accessCode === webinarAccessCode) {
      setError("")
      onSubmit(true) 
      setAccessCode("")
      onClose()
    } else {
      setError("Invalid access code")
    }
  }

  const handleClose = () => {
    setAccessCode("")
    setError("")
    onClose()
  }

  return (
    <Dialog   sx={{
    width: { xs: 'auto', md: '100%' }
  }} open={open} onClose={handleClose} aria-labelledby="access-code-dialog">
      <Paper >
        <DialogTitle sx={{ position: "relative" }}>
          <Typography
            sx={{
              m: "0",
              fontSize: "24px",
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            Enter Access Code
          </Typography>
          <IconButton
            sx={{
              top: "0px",
              right: "3px",
              color: "black",
              position: "absolute",
              width:{
              }
            }}
            size="small"
            onClick={handleClose}
          >
           <Icons.Cross/>
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          className="relative"
          sx={{
            ".MuiInputBase-root": { borderRadius: "6px" },
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <TextField
                size="small"
                name="accessCode"
                label="Access Code"
                variant="filled"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value)}
                error={!!error}
                helperText={error}
              />
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  sx={{
                    p: "9px 17px",
                    lineHeight: "1.5",
                    fontSize: "18px",
                  }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  sx={{
                    p: "9px 17px",
                    lineHeight: "1.5",
                    fontSize: "18px",
                    justifyContent: "center",
                  }}
                  type="submit"
                  color="secondary"
                  variant="contained"
                  disabled={!accessCode}
                >
                  Submit
                </Button>
              </Box>
            </Stack>
          </Box>
        </DialogContent>
      </Paper>
    </Dialog>
  )
}

export default AccessCodeDialog